module.exports = __webpack_public_path__ + "img/08_Screenshot 2025-06-13 at 14.03.03.56046d44.jpg";